import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SentEmailsPage } from "src/components/views/ai/sentEmails/SentEmailsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/customizations/sent-emails")({
	staticData: { title: i18n.t("sent_emails"), legacyViewKey: "sentEmailsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SentEmailsPage />;
}
